/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Ota_BundleInputs */

const en_mobile_ota_bundle = /** @type {(inputs: Mobile_Ota_BundleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Running bundle`)
};

const es_mobile_ota_bundle = /** @type {(inputs: Mobile_Ota_BundleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bundle en ejecución`)
};

/**
* | output |
* | --- |
* | "Running bundle" |
*
* @param {Mobile_Ota_BundleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_ota_bundle = /** @type {((inputs?: Mobile_Ota_BundleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Ota_BundleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_ota_bundle(inputs)
	return en_mobile_ota_bundle(inputs)
});